<template>
<section class="basic-content p-4">
    <SmoothLoader class="mx-auto" :class="width" v-html="data.content">
    </SmoothLoader>
</section>
</template>

<script>

export default {

    props: ['data'],

    setup(props) {
        let width = props.data?.container_width || 'narrow';
        let containers = {
            narrow: 'max-w-xl',
            wide: 'max-w-4xl',
            extra: 'max-w-6xl'
        }
        return {
            width: containers[width]
        }
    }

}
</script>